export default __webpack_public_path__ + "static/media/1.4eea50ff.png";